export default [
  {
    date: 1430347120616,
    row: 8,
    col: 9,
    segments: [
      [2, 1, 2, 2],
      [2, 2, 1, 2],
      [1, 2, 2, 3],
      [2, 3, 1, 3],
      [1, 3, 3, 6],
      [1, 7, 3, 6],
      [1, 7, 4, 8],
      [4, 8, 6, 5],
      [6, 5, 7, 7],
      [7, 7, 7, 5],
      [6, 4, 7, 5],
      [6, 4, 7, 3],
      [7, 3, 5, 2],
      [5, 2, 4, 5],
      [4, 5, 2, 1]
    ]
  }
];
